import { all } from 'redux-saga/effects'

import { submitSaga } from './submit/saga'

export function* applicationSaga() {
  yield all([submitSaga()])
}
